import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'tracking-statistic',
});

export async function getTrackingStats() {
    const tracking = await backendEndpoint.get();

    return tracking.data;
}
